import React, { useEffect, useRef, useState } from 'react';
import { useAuth } from '../../../Auth';
import { useAxios } from '../../../AxiosHandler';

import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import interactionPlugin from "@fullcalendar/interaction";
import resourceTimelinePlugin from '@fullcalendar/resource-timeline';

import moment from 'moment';

import './Bookingcalendar.scss';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import CalendarEventEditorModal from './CalendarEventEditorModal/CalendarEventEditorModal';

import StringToIcon from '../StringToIcon/StringToIcon';
import EditMaintenance from '../Maintenance/EditMaintenance/EditMaintenance';
import { useTranslate } from 'react-polyglot';

function Bookingcalendar(props) {
    const auth = useAuth();
    const axiosHandler = useAxios();
    const axios = axiosHandler.axios;
    const t = useTranslate();

    const calendarRef = useRef(null);

    const [editEvent, setEditEvent] = useState<any>();
    const [currentResourceId, setCurrentResourceId] = useState("");
    const [showEditMaintenance, setShowEditMaintenance] = useState(false);
    const [editMaintenanceKey, setEditMaintenanceKey] = useState("");

    const [bookingColors, setBookingColors] = useState<Array<any>>([]);

    const [events, setEvents] = useState<Array<any>>([]);

    function handleEditMaintenance(evt, resourceID, key) {
        setCurrentResourceId(resourceID);
        setEditMaintenanceKey(key);
        setShowEditMaintenance(true);
    }

    function eventTitle(from, to) {
        let suffix = "";
        if (!moment(from).isSame(moment(to), "day")) {
            if ((moment(from).startOf("day").diff(moment(to).startOf("day"), "days") * -1) > 1) {
                suffix = " Netter";
            } else {
                suffix = " Natt";
            }
            let days = moment(from).startOf("day").diff(moment(to).startOf("day"), "days") * -1;
            if (days == 0) days = 1;
            return days + suffix;
        } else {
            if ((moment(from).diff(moment(to), "hours") * -1) > 1) {
                suffix = " Timer";
            } else {
                suffix = " Time";
            }
            return (moment(from).diff(moment(to), "hours") * -1) + suffix;
        }
    }

    async function fetchColors() {
        if (!localStorage.getItem("bookingColors") || moment(JSON.parse(localStorage.getItem("bookingColors") || "{}").lastUpdate).isBefore(moment(new Date()).add(-1, "seconds"))) {
            await axios.single({
                method: "get",
                url: "/api/bookings/colors",
                responseType: "json",
                headers: {'x-access-token': auth.user["token"]}
            })
            .then((res) => {
                setBookingColors(res.data ?? []);
                localStorage.setItem("bookingColors", JSON.stringify({bookingColors: res.data, lastUpdate: new Date()}));
            })
            .catch(err => console.log(err));
        } else {
            setBookingColors(JSON.parse(localStorage.getItem("bookingColors") || "{}").bookingColors);
        }
    }

    function getEventName(booking) {
        let bookingColor = bookingColors?.find(i => i.bookingId == booking.bookingId);
        if (bookingColor != undefined && bookingColor.color != undefined) {
            return bookingColor.eventName;
        } else {
            return "";
        }
    }
    
    function getColor(booking) {
        let bookingColor = bookingColors?.find(i => i.bookingId == booking.bookingId);
        if (bookingColor != undefined && bookingColor.color != undefined) {
            return bookingColor.color;
        } else {
            return "#3694df";
        }
    }

    async function getEvents() {
        let events: Array<any> = [];

        props.resources.forEach(resource => {
            resource.bookings.forEach((booking, bookingkey) => {
                if (booking.bookingtimes == undefined ) booking.bookingtimes = [];
                if (booking.bookingId == "" || booking.bookingId == undefined){
                    booking.bookingtimes.forEach(bookingtime => {
                        if(props.editAll == undefined || props.editAll == false){
                            events.push({
                                id: resource.id + "-" + bookingtime.start,
                                title: bookingtime.state == "reserved" ? t("bookingcalendar.reserved") + " (" + bookingkey + ")" : t("bookingcalendar.occupied") + " (" + bookingkey + ")",
                                startStr: "",
                                endStr: "",
                                start: moment(bookingtime.start).toDate(),
                                end: moment(bookingtime.end).toDate(),
                                resourceId: resource._id,
                                allDay: false,
                                uuid: bookingtime.uuid,
                                booking,
                                backgroundColor: props.event != undefined ? props.event._id == bookingtime.eventId ? props.event.color : "#e4e4e4" : "#e4e4e4",//bookingtime.state == "new" ? "#2da432" : bookingtime.state == "current" ? getColor(booking) : "#e4e4e4",
                                borderColor: props.event != undefined ? props.event._id == bookingtime.eventId ? props.event.color : "#e4e4e4" : "#e4e4e4",
                                textColor: props.event != undefined ? props.event._id == bookingtime.eventId ? "white" : bookingtime.state == "current" ? "white" : "black" : "black",
                                classNames: bookingtime.state == "new" ? "event-new" : bookingtime.state == "current" ? "event-current" : "event-existing",
                                //editable: booking.state == "new" || booking.state == "current" ? true : false,
                            });
                        } else {
                            events.push({
                                id: resource.id + "-" + bookingtime.start,
                                title:
                                    props.showEventNames != true ?
                                        bookingtime.state == "reserved" ?
                                            t("bookingcalendar.reserved") + " (" + bookingkey + ")"
                                        :
                                            t("bookingcalendar.occupied") + " (" + bookingkey + ")"
                                    : props.event != undefined ? 
                                            props.event.name
                                        :
                                            bookingtime.state == "reserved" ?
                                                t("bookingcalendar.reserved") + " (" + bookingkey + ")"
                                            :
                                                t("bookingcalendar.occupied") + " (" + bookingkey + ")"
                                        ,
                                startStr: "",
                                endStr: "",
                                start: moment(bookingtime.start).toDate(),
                                end: moment(bookingtime.end).toDate(),
                                resourceId: resource._id,
                                allDay: false,
                                uuid: bookingtime.uuid,
                                booking,
                                backgroundColor: props.event != undefined ? props.event._id == bookingtime.eventId ? props.event.color : "#e4e4e4" : "#e4e4e4",//bookingtime.state == "new" ? "#2da432" : bookingtime.state == "current" ? getColor(booking) : "#e4e4e4",
                                borderColor: props.event != undefined ? props.event._id == bookingtime.eventId ? props.event.color : "#e4e4e4" : "#e4e4e4",
                                textColor: props.event != undefined ? props.event._id == bookingtime.eventId ? "white" : bookingtime.state == "current" ? "white" : "black" : "black",
                                classNames: bookingtime.state == "new" ? "event-new" : bookingtime.state == "current" ? "event-current" : "event-existing",
                                //editable: booking.state == "new" || booking.state == "current" ? true : false,
                            });
                        }
                    });
                } else {
                    booking.bookingtimes.forEach(bookingtime => {
                        //if (props.bookingId != undefined) {
                        if (booking.bookingId == props.bookingId) {
                            if (bookingtime.state != "new") bookingtime.state = "current";
                        } else {
                            if (bookingtime.state != "new") bookingtime.state = "existing";
                        }
                        //}
                        
                        if (props.editAll == undefined || props.editAll == false) {
                            events.push({
                                id: resource.id + "-" + bookingtime.start,
                                title:
                                    props.showEventNames != true ?
                                        bookingtime.state == "existing" ?
                                            t("bookingcalendar.occupied") + " (" + bookingkey + ")"
                                        :
                                            eventTitle(bookingtime.start, bookingtime.end)
                                    :
                                        getEventName(booking),
                                startStr: "",
                                endStr: "",
                                start: moment(bookingtime.start).toDate(),
                                end: moment(bookingtime.end).toDate(),
                                resourceId: resource._id,
                                allDay: false,
                                uuid: bookingtime.uuid,
                                booking,
                                backgroundColor: bookingtime.state == "new" ? "#2da432" : bookingtime.state == "current" ? getColor(booking) : props.event != undefined && props.event._id == bookingtime.eventId ? props.event.color : "#e4e4e4",
                                borderColor: bookingtime.state == "new" ? "#2da432" : bookingtime.state == "current" ? getColor(booking) : props.event != undefined && props.event._id == bookingtime.eventId ? props.event.color : "#e4e4e4",
                                textColor: bookingtime.state == "new" ? "white" : bookingtime.state == "current" ? "white" : "black",
                                classNames: bookingtime.state == "new" ? "event-new" : bookingtime.state == "current" ? "event-current" : "event-existing",
                                //editable: booking.state == "new" || booking.state == "current" ? true : false,
                            });
                        } else {
                            events.push({
                                id: resource.id + "-" + bookingtime.start,
                                title:
                                    props.showEventNames != true ?
                                        bookingtime.state == "existing" ?
                                            t("bookingcalendar.occupied") + " (" + bookingkey + ")"
                                        :
                                            eventTitle(bookingtime.start, bookingtime.end)
                                    :
                                        getEventName(booking),
                                start: moment(bookingtime.start).toDate(),
                                end: moment(bookingtime.end).toDate(),
                                resourceId: resource._id,
                                allDay: false,
                                uuid: bookingtime.uuid,
                                booking,
                                backgroundColor: bookingtime.state == "new" ? "#2da432" : bookingtime.state == "current" ? getColor(booking) : getColor(booking),
                                borderColor: bookingtime.state == "new" ? "#2da432" : bookingtime.state == "current" ? getColor(booking) : getColor(booking),
                                textColor: bookingtime.state == "new" ? "white" : bookingtime.state == "current" ? "white" : "white",
                                classNames: bookingtime.state == "new" ? "event-new" : bookingtime.state == "current" ? "event-current" : "event-current",
                            });
                        }
                    });
                }
                
            });
        });
        setEvents(events);
    }

    useEffect(() => {
        if (calendarRef.current != null) {
            let api = (calendarRef.current as any).getApi();
            api.updateSize();
        }
        getEvents();
    }, [props.forceUpdate]);

    useEffect(() => {
        getEvents();
        setBookingColors(JSON.parse(localStorage.getItem("bookingColors") || "{}").bookingColors);
    }, [props.resources]);

    useEffect(() => {
        fetchColors();
        getEvents();
    }, []);

    return (
        <div className="bookingcalendar" style={props.style != undefined ? props.style : null}>
            <FullCalendar
                ref={calendarRef}
                plugins={[dayGridPlugin, resourceTimelinePlugin, interactionPlugin]}
                initialView="resourceTimelineOnemonth"
                schedulerLicenseKey="0022145730-fcs-1611561300"
                locale="nb"
                headerToolbar={{
                    left: 'prev,next',
                    center: 'title',
                    right: 'resourceTimelineThreemonths,resourceTimelineOnemonth,dayOneweek,dayTwoweeks'
                }}
                displayEventTime={false}
                height={props.height != undefined ? props.height : "800px"}
                themeSystem="bootstrap"
                slotMinWidth={26}
                slotLabelFormat={[
                    { month: 'long', year: 'numeric' }, // top level of text
                    { day: 'numeric' } // lower level of text
                ]}
                views={{
                    resourceTimelineThreemonths: {
                        buttonText: "3 Måneder",
                        type: 'resourceTimeline',
                        duration: { months: 3 }
                    },
                    resourceTimelineOnemonth: {
                        buttonText: "1 Måned",
                        type: 'resourceTimeline',
                        duration: { months: 1 }
                    },
                    dayOneweek: {
                        buttonText: "1 Uke",
                        type: 'dayGridWeek',
                        duration: { days: 7 }
                    },
                    dayTwoweeks: {
                        buttonText: "2 Uker",
                        type: 'dayGridWeek',
                        duration: { days: 14 }
                    },
                    // Not working in React version of FullCalendar? Might need to update to latest version
                    /*listOneWeek: {
                        buttonText: "Liste",
                        type: 'listWeek',
                        duration: { days: 7 }
                    },*/
                }}
                eventResize={(evt) => {
                    if (evt != null) {
                        // let oldRange = (evt as any).oldEvent._instance.range;
                        // let newRange = (evt as any).event._instance.range;
                        // let resourceId = (evt as any).event._def.resourceIds[0];
                    }
                }}
                events={ events }
                resourceGroupField="location"
                resourcesInitiallyExpanded={true}
                resourceAreaColumns={[
                    ...(props.resources != undefined && props.resources.some(i => i.resourceTypeName != undefined) ?
                        [
                            /*{
                                field: 'location',
                                headerContent: 'Lokasjon',
                                group: true,
                                cellContent: (data) => {
                                    let type = data.groupValue != undefined ? data.groupValue : data.fieldValue != undefined ? data.fieldValue : data.resource?._resource.extendedProps.resourceTypeName;
                                    return <span onClick={() => {
                                        //console.log("Clicked Type: ", data);
                                    }}>{type}</span>;
                                }
                            }*/
                        ]
                        : []),
                    {
                        field: 'title',
                        headerContent: 'Ressurs',
                        cellContent: (data) => {
                            let type = data.resource?._resource.extendedProps.name;
                            return <span className={props.resourceClicked != undefined ? "clickable" : ""} style={props.resourceClicked != undefined ? { cursor: "pointer" } : {}} onClick={() => {
                                if (props.resourceClicked != undefined) {
                                    props.resourceClicked(data.resource?._resource.extendedProps);
                                }
                            }}>{type}</span>;
                        }
                    },
                    {
                        field: 'lname',
                        headerContent: 'Vedlikehold',
                        cellContent: (data) => {
                            const resourceID = data.resource?._resource.extendedProps._id
                            let maintenanceList = data.resource?._resource.extendedProps.openMaintenance;
                            if (maintenanceList != undefined) {
                                return (<div className='maintainanceiconbox'>{
                                    maintenanceList.map((maintenance, i) =>
                                        <OverlayTrigger
                                            key={i}
                                            placement={"top"}
                                            overlay={
                                                <Tooltip id={`tooltip-${"top"}`}>
                                                    {maintenance.name}: {maintenance.description}
                                                </Tooltip>
                                            }
                                        >
                                            <StringToIcon style={{color: "black", fontSize: "18px", cursor: "pointer", marginRight: "0px"}} icon={maintenance["type"]} onClick={(evt) => handleEditMaintenance(evt, resourceID, maintenance.key)} />
                                        </OverlayTrigger>
                                    )
                                } </div>)
                            }
                        }
                    },
                ]}
                resources={props.resources != undefined ? props.resources.map(r => { return { ...r, title: r.name, id: r._id } }) : []} // { id: "1", title: "Room 101" }
                eventClick={(evt) => {
                    if (props.clickable == undefined || props.clickable == true) {
                        if (evt != undefined /*&& evt.event._def.ui.backgroundColor != "#e4e4e4"*/) {
                            setEditEvent({
                                name: (evt as any).event._def.title,
                                resourceId: (evt as any).event._def.resourceIds[0],
                                start: (evt as any).event._instance.range.start,
                                end: (evt as any).event._instance.range.end,
                                source: (evt as any).event,
                                booking: (evt as any).event._def.extendedProps.booking
                            });

                            if (props.eventClick != undefined) {
                                props.eventClick(evt);
                            }
                        }
                    }
                }}
                dateClick={(evt) => {
                    if (props.clickable == undefined || props.clickable == true) {
                        if (props.dateClick != undefined) {
                            props.dateClick(evt);
                        }
                    }
                }}
            />
            <CalendarEventEditorModal
                event={editEvent}
                show={editEvent != undefined}
                resources={props.resources}
                onCancel={() => setEditEvent(undefined)}
                onHide={() => setEditEvent(undefined)}
                showBookingInfo={props.editorShowBookingInfo}
                showBookingLink={props.editorShowBookingLink}
                onDelete={(event) => {
                    let eventUuid = event.source.extendedProps.uuid;
                    let foundResource = props.resources.find(r => r._id == event.resourceId);

                    if (foundResource != undefined) {
                        let foundBooking = foundResource.bookings.find(b => b.uuid == event.source.extendedProps.booking.uuid);

                        let foundEvent = foundBooking.bookingtimes.find(e => e.uuid == eventUuid);
                        if (foundEvent != undefined) {
                            let restEvents = foundBooking.bookingtimes.filter(e => e.uuid != eventUuid);
                            foundBooking.bookingtimes = restEvents;
                        }

                        foundResource.bookings = foundResource.bookings.filter(i => i.uuid != event.source.extendedProps.booking.uuid);
                        foundResource.bookings.push(foundBooking);
                    }

                    let restResources = props.resources.filter(r => r._id != event.resourceId);
                    restResources.push(foundResource);

                    if (props.onChange != undefined) {
                        props.onChange(JSON.parse(JSON.stringify(restResources)), foundResource);
                    }
                    setEditEvent(undefined);
                }}
                onChange={(event) => {
                    let eventUuid = event.source.extendedProps.uuid;
                    let foundResource = props.resources.find(r => r._id == event.resourceId);

                    if (foundResource != undefined) {
                        let foundBooking = foundResource.bookings.find(b => b.bookingtimes.map(t => t.uuid).includes(eventUuid));

                        let foundEvent = foundBooking.bookingtimes.find(e => e.uuid == eventUuid);
                        if (foundEvent != undefined) {
                            let restEvents = foundBooking.bookingtimes.filter(e => e.uuid != eventUuid);
                            restEvents.push({
                                ...foundEvent,
                                //state: "new",
                                start: event.start,
                                end: event.end
                            });
                            foundBooking.bookingtimes = restEvents;
                        }

                        foundResource.bookings = foundResource.bookings.filter(i => i.bookingId != foundBooking.bookingId);
                        foundResource.bookings.push(foundBooking);
                    }

                    let restResources = props.resources.filter(r => r._id != event.resourceId);

                    restResources.push(foundResource);

                    if (props.onChange != undefined) {
                        props.onChange(restResources, foundResource);
                    }
                    setEditEvent(undefined);
                }}
                confirmBtnText={props.confirmBtnText}
            ></CalendarEventEditorModal>

            <EditMaintenance
                showEditMaintenance={showEditMaintenance}
                setShowEditMaintenance={setShowEditMaintenance}
                resourceID={currentResourceId}
                maintenanceKey={editMaintenanceKey}
                runOnEdit={() => {
                    if(props.fetchDataPass != undefined){
                        props.fetchDataPass();
                    }
                }}
            />

        </div>
    );
}

export default Bookingcalendar;
